import React from 'react';
import { useSelector } from 'react-redux';

import { TabHeader } from '../shared/tabHeader.component';
import { AdminOption } from '../shared/adminOption.component';
import { useRollToNextPeriod, useRefreshLeCc } from '../../../shared/mutations/clientAdministration';
import { clientLegalEntitySourceSelector } from '../../../shared/store/selectors';

const TLS_LEGAL_ENTITY_SOURCE = 'TLS';

const RollTab = () => {
  const clientLegalEntitySource = useSelector(clientLegalEntitySourceSelector);

  const { mutate: rollToNextPeriod, isLoading: isRollingToNextPeriod } = useRollToNextPeriod();
  const { mutate: refreshLeCc, isLoading: isRefreshingLeCc } = useRefreshLeCc();

  const isRefreshOptionEnabled = clientLegalEntitySource !== TLS_LEGAL_ENTITY_SOURCE;

  return (
    <div className="roll-tab">
      <div className="container-fluid">
        <div className="application-settings-form">
          <TabHeader label="Roll" />
          <AdminOption
            label="Roll to next period"
            buttonLabel="Roll"
            isLoading={isRollingToNextPeriod}
            disabled={isRefreshingLeCc}
            onClick={rollToNextPeriod}
          />
          {
            isRefreshOptionEnabled && <AdminOption
              label="Refresh LE/CC"
              buttonLabel="Refresh"
              isLoading={isRefreshingLeCc}
              disabled={isRollingToNextPeriod}
              onClick={refreshLeCc}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default RollTab;
